import { AuthenticatingSection } from "../AuthenticatingSection";
import { EmailDisplayBox } from "../EmailDisplayBox";
import { useEmailVerificationPasswordState } from "../hooks/useEmailVerificationPasswordState";
import { FooterSection } from "./FooterSection";
import { PasswordFormSection } from "./PasswordFormSection";

interface EmailVerificationPasswordStateProps {
  email: string;
  error?: string | null;
  isSubmitting?: boolean;
  isSubmittingForgotPassword?: boolean;
  onClose: () => void;
  onForgotPasswordSubmit?: () => void;
  onPasswordSubmit?: (password: string) => void;
  onShowOTPForm: () => void;
}

export const EmailVerificationPasswordState = ({
  email,
  onClose,
  onShowOTPForm,
  onPasswordSubmit,
  onForgotPasswordSubmit,
  isSubmitting = false,
  isSubmittingForgotPassword = false,
  error = null,
}: EmailVerificationPasswordStateProps) => {
  const {
    password,
    hasError,
    isSuccessShown,
    handleSubmit,
    handlePasswordChange,
    handleKeyDown,
  } = useEmailVerificationPasswordState({
    isSubmitting,
    error,
    onPasswordSubmit,
  });

  const isSubmittingRequests = isSubmitting || isSubmittingForgotPassword;
  const shouldShowSuccess = isSuccessShown && !isSubmittingRequests;
  const shouldShowActions = !isSubmittingRequests && !shouldShowSuccess;

  return (
    <div className="flex flex-col gap-5 pb-6 *:px-6">
      <EmailDisplayBox email={email} onClose={onClose} />

      <PasswordFormSection
        password={password}
        hasError={hasError}
        isSubmitting={isSubmitting}
        isSubmittingForgotPassword={isSubmittingForgotPassword}
        shouldShowActions={shouldShowActions}
        onPasswordChange={handlePasswordChange}
        onKeyDown={handleKeyDown}
        onSubmit={handleSubmit}
      />

      {(isSubmittingRequests || shouldShowSuccess) && (
        <AuthenticatingSection
          shouldShowMessage={isSubmitting || shouldShowSuccess}
          messageType={shouldShowSuccess ? "success" : "authenticating"}
        />
      )}
      {shouldShowActions && (
        <FooterSection
          isSubmitting={isSubmitting}
          isSubmittingForgotPassword={isSubmittingForgotPassword}
          onForgotPasswordSubmit={onForgotPasswordSubmit}
          onShowOTPForm={onShowOTPForm}
        />
      )}
    </div>
  );
};
